<template>
  <div class="main-content-box">
    <bannerEl/>
    <configZone1El/>
    <configZone2El/>
  </div>
</template>

<script>
import bannerEl from "@/views/page/racemascot/banner";
import configZone1El from "@/views/page/racemascot/config_zone_1";
import configZone2El from "@/views/page/racemascot/config_zone_2";

export default {
  name: "page_racemascot",
  components:{
    bannerEl,
    configZone1El,
    configZone2El,
  },
  data() {
    return {

    }
  },
  computed: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.main-content-box{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}
</style>
